import Link from "next/link";

import classNames from "classnames";

import { CE_04, CategoryVariant } from "@helpers/plasmic/slices";

import ImageWrapper from "@components/swagmagic/dynamic/cards/image-wrapper";

import styles from "./main.module.scss";

export type DetailedInfoCardProps = {
  variant: CategoryVariant;
  src: string;
  url: string;
  title: string;
  description: string;
  linkToNewTab?: boolean;
  btnText?: string;
};

const DetailedInfoCard = (props: DetailedInfoCardProps) => {
  const {
    variant,
    src,
    url,
    title,
    description,
    linkToNewTab = false,
    btnText = "View All",
  } = props;
  return (
    <div
      className={classNames(styles.cardContainer, {
        [styles.widerImageBlock]: variant === CE_04,
      })}
    >
      <ImageWrapper
        src={src}
        alt={title}
        imageWrapperClassName={classNames(styles.cardImageHolder)}
        imageClassName={styles.cardImage}
        noImageText={title}
        showNoImageTextUppercase={false}
      />
      <div className={styles.cardContent}>
        <div className={styles.cardTitle}>{title}</div>
        <div className={styles.cardDescription}>{description}</div>
        {url ? (
          <Link
            target={linkToNewTab ? "_blank" : "_self"}
            href={url}
            className={styles.cardLink}
            aria-labelledby={btnText}
            prefetch={false}
          >
            {btnText}
          </Link>
        ) : (
          <div className={styles.cardLink}>{btnText}</div>
        )}
      </div>
    </div>
  );
};

export default DetailedInfoCard;
